import { useNavigate } from "react-router-dom";
import "./Resources.css";

const Resources = () => {
    const navigate = useNavigate();

    const resourceCategories = [
        { 
            title: "Company Type",
            items: [
                { title: "Single-Member vs. Multi-Member LLC", link: "/single-member-vs-multi-member-llc-which-one-is-right-for-you?" },
                { title: "LLC vs. C Corp: Which structure is right for me?", link: "/llc-vs-c-corporation-which-business-structure-is-right-for-you?" },
            ]
        },
        { 
            title: "State of Incorporation",
            items: [
                { title: "What are the benefits of Wyoming LLCs?", link: "/why-choose-a-wyoming-llc?" },
            ]
        },
        { 
            title: "Restrictions and Requirements",
            items: [
                { title: "Do you have any restricted countries?", link: "/are-there-any-restricted-countries-for-company-incorporation-in-the-usa?" },
            ]
        },
        { 
            title: "Company Name",
            items: [
                { title: "Restricted business names such as University and Bank", link: "/restricted-business-names-in-the-us-what-you-need-to-know" },
            ]
        },
    
    ];

    return (
        <div className="rs-container">
            {/* <header className="rs-header">
                <div className="rs-container-1200">
                    <div className="rs-header-content">
                        <button 
                            className="rs-back-btn"
                            onClick={() => navigate(-1)}
                        >
                            <FaArrowLeft /> Back
                        </button>
                        <div className="rs-logo">
                            <a href="/">BooksComply</a>
                        </div>
                        <div className="rs-top-bar">
                            <a href="/submitrequest" className="rs-submit-btn">
                                <FaQuestionCircle className="btn-icon" /> Submit a request
                            </a>
                        </div>
                    </div>
                </div>
            </header> */}
            
            <main className="rs-main-content">
                <div className="rs-container-1200">
                    <nav className="rs-breadcrumb">
                        <ol>
                            <li><a href="/help">Help Center</a></li>
                            <li>Resources</li>
                        </ol>
                    </nav>

                    <div className="rs-header-content">
                        <div>
                            <h1>Resources</h1>
                            <p className="rs-subtitle">Helpful guides, templates, and additional information for your business</p>
                        </div>
                    </div>

                    <div className="rs-categories-grid">
                        {resourceCategories.map((category, index) => (
                            <div key={index} className="rs-category-card">
                                <div className="rs-category-header">
                                    <h2>{category.title}</h2>
                                </div>
                                <ul className="rs-resource-list">
                                    {category.items.map((item, itemIndex) => (
                                        <li key={itemIndex} className="rs-resource-item">
                                            <a 
                                                href={item.link}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    navigate(item.link);
                                                }}
                                            >
                                                {item.title}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>

                    <div className="rs-contact-section">
                        <h2>Can't find what you're looking for?</h2>
                        <p>Our support team is here to help you with any questions about our resources or services.</p>
                        <a href="/submitRequest" className="rs-contact-btn">Contact Support</a>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default Resources;